<template>
    <component :is="componentLoader"></component>
</template>

<script>


    const gameNameMapper = {
        'yoga': 'GameYoga',
        'running': 'GameRunning',
        'workout': 'GameWorkout'
    };

    export default {
        name: "Game",
        computed: {
            componentLoader() {
                return () => import("@/components/"+gameNameMapper[this.$route.params.id]+".vue");
            }
        }
    }
</script>
